import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { SaveVehicleNotifyRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { GVehicleNotifyViewModel } from 'src/app/viewmodels/g-vehicle/GVehicleNotifyViewModel';
import { ItemViewModel } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-notify-form',
  templateUrl: './notify-form.component.html',
  styleUrls: ['./notify-form.component.scss']
})
export class NotifyFormComponent implements OnInit {
  @Input() public vm: SaveVehicleNotifyRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public vehicleDetail: any = [];
  public selectedvehicleDetail: any = [];
  modalRefLv1: BsModalRef;
  modalRef: BsModalRef;
  public statusList: any = [];
  public vehicleStatus: number = 0;
  files: File[] = [];
  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: "id",
    textField: "registrationNumber",
    enableCheckAll: false,
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }
  ngOnInit() {
    debugger;

    this.getRegNo();
    this.getStatusList();
    if (this.vm.id != null && this.vm.id != 0 && this.vm.id != undefined) {
      this.selectedvehicleDetail[0] = {
        id: this.vm.vehicle.id,
        registrationNumber: this.vm.vehicle.name
      };
    }
  }
  onSelect(e) {
    debugger
    this.files.push(...e.addedFiles);

    this.vm.file = this.files;
  }
  onRemove(e) {
    console.log(e);
    this.files.splice(this.files.indexOf(e), 1);
  }
  getRegNo() {
    this.spinner.show();
    this._uow.gSettingService.GetGVehiclesAsync().subscribe(
      (res: any) => {
        debugger
        this.vehicleDetail = res.result;
        console.log(res);
        this.spinner.hide();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this.spinner.hide();
      }
    );
  }

  onSelectvehicleDetail(e) {
    debugger
    this._uow.logger.log(e);

    let item = this.vehicleDetail.find((x) => x.id === e.id);

    if (item !== undefined) {
      console.log(item);
      this.vm.customerName = item.customer.name;
      this.vm.customerEmail = item.customerEmail.name;
      this.vm.driverName = item.driverName;
      this.vm.driverPhone = item.driverPhone;
      this.vm.lastOdometer = item.odometer;
      this.vm.customerBrand = item.brand.name;
      this.vehicleStatus = item.status.id;
    }
  }

  onDeSelectvehicleDetail(e) {
    if (this.selectedvehicleDetail.length == 0) {
      this.vm = new SaveVehicleNotifyRequest();
      this.getRegNo();
    }
  }

  getStatusList() {
    // this._jq.showSpinner(true);
    this.spinner.show();
    this._uow.gSettingService.GetVehicleStatusesAsync().subscribe((res: any) => {
      debugger
      this.statusList = res.result;
      if (this.vm.id != null && this.vm.id != 0 && this.vm.id != undefined) {
        this.vehicleStatus = this.vm.status.id;
      }
      console.log(res);
      this.spinner.hide();
      // this._jq.showSpinner();
    }, (err) => {
      console.log(err);
      this.spinner.hide();
      // this._jq.showSpinner();
    });
  }

  saveOrUpdate() {
    debugger
    // if(this.vehicleStatus == 0 || this.vehicleStatus == null || this.vehicleStatus == undefined){
    //   Swal.fire(
    //     'Failure!',
    //     'Update the status from vehicle!',
    //     'error'
    //   )
    //   return;
    // }
    this.spinner.show();
    this.vm.vehicle = {
      id: this.selectedvehicleDetail[0].id,
      name: this.selectedvehicleDetail[0].registrationNumber
    };

    if(this.vehicleStatus == undefined || this.vehicleStatus == null){
      Swal.fire(
          'Failure!',
          'Status not selected against this vehicle.',
          'error'
        );
        this.spinner.hide();
        return;
    }
    else{
      this.vm.status = {
      id: this.vehicleStatus,
      name: ""
    };
    }
    
    this._uow.gSettingService
      .SaveVehicleNotifyAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
        console.log(error);
        this.spinner.hide();
      });
  }

   closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
